var map = {
	"./annotationHistory/sagas.js": 795,
	"./app/sagas.js": 798,
	"./box/sagas.js": 799,
	"./cuboid/sagas.js": 800,
	"./image/sagas.js": 801,
	"./issues/sagas.js": 504,
	"./keyboard/sagas.js": 546,
	"./labelingHistory/sagas.js": 802,
	"./mouse/sagas.js": 803,
	"./notification/sagas.js": 547,
	"./ocr/sagas.js": 804,
	"./permission/sagas.js": 805,
	"./points/sagas.js": 806,
	"./polygon/sagas.js": 807,
	"./polyline/sagas.js": 808,
	"./segmentation/sagas.js": 809,
	"./shape/sagas.js": 810,
	"./socket/sagas.js": 198,
	"./timing/sagas.js": 811,
	"./tools/sagas.js": 576
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 501;